'use client'

import React from 'react'
import { cn } from '@/utilities/ui'
import { Check } from 'lucide-react'

type PropertyFeaturesProps = {
  className?: string
  features?: Record<string, boolean | null | undefined>
  dictionary: any
}

const PropertyFeatures = ({ className, features, dictionary }: PropertyFeaturesProps) => {
  const trueFeatures = Object.entries(features || {})
    .filter(([_, value]) => value === true) // ← only include `true`, not null/undefined
    .map(([key]) => key)

  if (trueFeatures.length === 0) {
    return null // or show "No features available"
  }

  return (
    <div className={cn('bg-card container mx-auto rounded-xl shadow-sm p-[30px]', className)}>
      <h2 className="text-typography text-[17px] font-semibold mb-6">
        {dictionary?.propertyDetail?.featuresAmenities || 'Features & Amenities'}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-4">
        {trueFeatures.map((feature, index) => (
          <div key={index} className="flex items-center">
            <span className="mr-2 text-typography">•</span>
            <span className="text-typography text-sm">
              {dictionary.propertyListing.features[feature]}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PropertyFeatures
